module.exports = __webpack_public_path__ + "static/img/20007 (4).c81ae25.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20007 (4).webp
// module id = mwud
// module chunks = 14